module.exports = __webpack_public_path__ + "files/EHPAD-SPIADI-2020-2024.ea4012e74ee3973dfd7a5b7cf011b18c.pdf";